// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"6cb782e7","751":"f3c5287f"}[chunkId] + ".chunk.css";
};